import SortBySelect from "@/components/data-input/SortBySelect";
import useRouterPush from "@/hooks/useRouterPush";
import { formatSortOptions } from "@/utils/helpers/sort";

function SortFilter({ sortOptions }) {
  const options = formatSortOptions(sortOptions);
  const { queryParams, updateQueryParams } = useRouterPush();

  const getSelectedOption = (sort_by) => {
    return options.find((option) => option.value === sort_by);
  };

  return (
    <SortBySelect
      options={options}
      value={getSelectedOption(queryParams.sort_by) || null}
      className="hidden md:flex"
      onChange={(data) => updateQueryParams({ sort_by: data.value, page: 1 })}
    />
  );
}

export default SortFilter;
